import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./../Pages/Login";
import Register from "./../Pages/Register";
import "./../Styles/cart.css";
import { API } from "./../../config/api";
import { BASE_URL } from "./../../config/api";
export default function Cart() {
  useEffect(() => {
    document.title = "Checkout";
  }, []);
  const navigate = useNavigate();

  const [cartData, setCartData] = useState([]);
  const [user, setUser] = useState(null);
  const [selected, setSelected] = useState({});
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [balance, setBalance] = useState(0);
  const handleAddBalance = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user) {
      navigate("/balance");
    } else {
      setShowLogin(true);
    }
  };
  /* ================= LOAD USER + FETCH CART ================= */
  useEffect(() => {
    const loadUser = () => {
      const loginUser = JSON.parse(localStorage.getItem("user"));
      // console.log("USER:", loginUser);

      setUser(loginUser);

      if (loginUser) {
        const userId = loginUser.user_login_id || loginUser.id;
        // console.log("USER ID:", userId);

        if (userId) {
          fetchCart(userId);
          fetchBalance(userId);
        }
      }
    };

    loadUser();

    window.addEventListener("userLogin", loadUser);
    window.addEventListener("userLogout", loadUser);

    return () => {
      window.removeEventListener("userLogin", loadUser);
      window.removeEventListener("userLogout", loadUser);
    };
  }, []);

  const toggleSelect = (cartId) => {
    setSelected((prev) => ({
      ...prev,
      [cartId]: !prev[cartId],
    }));
  };
  const toggleAll = (e) => {
    const checked = e.target.checked;
    const newSelected = {};

    cartData.forEach((item) => {
      newSelected[item.cart_id] = checked;
    });

    setSelected(newSelected);
  };
  const moveSelectedToWishlist = async () => {
    const selectedItems = cartData.filter((item) => selected[item.cart_id]);

    if (selectedItems.length === 0) {
      alert("Please select at least one design");
      return;
    }

    try {
      const userId = user.user_login_id || user.id;

      await Promise.all(
        selectedItems.map((item) =>
          fetch(
            `https://lifetimedesign.in/LtcJsonAPI.asmx/Movetowishlist?user_id=${userId}&cart_id=${item.cart_id}`,
          ),
        ),
      );

      setCartData((prev) => prev.filter((item) => !selected[item.cart_id]));
      window.dispatchEvent(new Event("cartUpdated"));
      window.dispatchEvent(new Event("wishlistUpdated"));

      setSelected({});

      alert("Selected designs moved to wishlist");
    } catch (err) {
      console.error(err);
    }
  };
  /* ================= FETCH CART API ================= */
  const fetchCart = async (userId) => {
    try {
      const res = await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/Getcartlist?user_id=${userId}`,
      );

      const text = await res.text();
      // console.log("RAW RESPONSE:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = JSON.parse(JSON.parse(text));
      }

      // console.log("PARSED DATA:", data);

      setCartData(data?.data || []);
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error("Cart API Error:", err);
    }
  };
  const fetchBalance = async (userId) => {
    try {
      // console.log("👉 Fetching balance for:", userId);

      const res = await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/GetBalance?userid=${userId}`,
      );

      const json = await res.json();
      // console.log("👉 Raw Response:", json);

      let parsed = json;

      // 🔥 Handle .asmx format
      if (json.d) {
        if (typeof json.d === "string") {
          parsed = JSON.parse(json.d);
        } else {
          parsed = json.d;
        }
      }

      // console.log("👉 Parsed:", parsed);

      const balanceValue =
        parsed?.data?.currentbalance ||
        parsed?.currentbalance ||
        parsed?.Balance ||
        0;

      // console.log("👉 Final Balance:", balanceValue);

      setBalance(Number(balanceValue) || 0);
    } catch (err) {
      console.error("❌ Balance API Error:", err);
      setBalance(0);
    }
  };
  /* ================= REMOVE ITEM ================= */
  const removeItem = async (cartId) => {
    try {
      const userId = user.user_login_id || user.id;

      await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/RemoveCartDesign?cart_id=${cartId}&user_id=${userId}`,
      );

      setCartData((prev) => prev.filter((item) => item.cart_id !== cartId));
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error(err);
    }
  };
  /* ================= REMOVE ALL ================= */
  const removeAll = async () => {
    if (!window.confirm("Remove all items?")) return;

    try {
      const userId = user.user_login_id || user.id;

      await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/ClearCartlist?user_id=${userId}`,
      );

      setCartData([]);
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= SEND ORDER ================= */
  // const handleSendOrder = async () => {
  //   if (!user) {
  //     setShowLogin(true);
  //     return;
  //   }

  //   if (cartData.length === 0) {
  //     alert("Your cart is empty!");
  //     return;
  //   }

  //   // Confirmation Message
  //   const confirmOrder = window.confirm(
  //     `Are you sure you want to process this order?\n\nTotal Designs: ${cartData.length}\nTotal Amount: ₹${total}`,
  //   );

  //   if (!confirmOrder) {
  //     return;
  //   }

  //   try {
  //     const userId = user.user_login_id || user.id;

  //     const designIds = cartData.map((item) => item.design_id).join(",");

  //     const res = await fetch(
  //       `https://lifetimedesign.in/LtcJsonAPI.asmx/InsertOrderBulk?userid=${userId}&designIds=${designIds}`,
  //     );

  //     const text = await res.text();

  //     let data;
  //     try {
  //       data = JSON.parse(text);
  //     } catch {
  //       data = JSON.parse(JSON.parse(text));
  //     }

  //     if (data.success) {
  //       await fetch(
  //         `https://lifetimedesign.in/LtcJsonAPI.asmx/ClearCartlist?user_id=${userId}`,
  //       );

  //       setCartData([]);
  //       window.dispatchEvent(new Event("cartUpdated"));

  //       alert("Order placed successfully!");

  //       navigate("/myorders");
  //     } else {
  //       alert("Something went wrong.");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     alert("Failed to place order.");
  //   }
  // };
  const handleSendOrder = async () => {
    if (!user) {
      setShowLogin(true);
      return;
    }

    if (cartData.length === 0) {
      alert("Cart empty");
      return;
    }

    const ok = window.confirm(
      `Place order?\n\nItems: ${cartData.length}\nTotal: ₹${total}`,
    );

    if (!ok) return;

    try {
      const userId = user.user_login_id || user.id;

      const res = await fetch(`${BASE_URL}/send-order.php`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          user_id: userId,
        }),
      });

      const result = await res.json();

      console.log("ORDER RESULT:", result);

      if (result.success) {
        setCartData([]);
        setSelected({});

        window.dispatchEvent(new Event("cartUpdated"));

        await fetchBalance(userId);

        window.dispatchEvent(new Event("balanceUpdated"));

        alert("Order placed successfully");

        navigate("/myorders");
      } else {
        alert(result.message);

        console.log(result);
      }
    } catch (err) {
      console.error(err);

      alert("Server error");
    }
  };

  /* ================= MOVE TO WISHLIST ================= */
  const moveToWishlist = async (item) => {
    try {
      const userId = user.user_login_id || user.id;

      await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/Movetowishlist?user_id=${userId}&cart_id=${item.cart_id}`,
      );

      // remove from UI
      setCartData((prev) => prev.filter((i) => i.cart_id !== item.cart_id));

      window.dispatchEvent(new Event("cartUpdated"));
      window.dispatchEvent(new Event("wishlistUpdated"));
    } catch (err) {
      console.error(err);
    }
  };
  /* ================= TOTAL ================= */
  const total = cartData.reduce(
    (sum, item) => sum + Number(item.price || 0),
    0,
  );

  const isInsufficientBalance = balance < total;
  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },
    {
      label: "Cart",
      link: "/cart",
    },
  ];
  /* ================= NOT LOGGED IN ================= */
  if (!user) {
    return (
      <div className="container text-center mt-5 py-5 border rounded bg-light shadow-sm">
        <i className="bi bi-cart-x fs-1 text-muted"></i>
        <h4 className="mt-3 fw-bold">Please Login to View Your Cart</h4>
        <p className="text-muted">
          You need to be logged in to manage your items.
        </p>

        <button
          className="btn btn-primary px-5 py-2 mt-2 fw-bold"
          onClick={() => setShowLogin(true)}
        >
          Login Now
        </button>

        <Login
          isOpen={showLogin}
          onClose={() => setShowLogin(false)}
          openRegister={() => {
            setShowLogin(false);
            setShowRegister(true);
          }}
        />

        <Register
          isOpen={showRegister}
          onClose={() => setShowRegister(false)}
          openLogin={() => {
            setShowRegister(false);
            setShowLogin(true);
          }}
        />
      </div>
    );
  }
  const remaining = balance - total;
  /* ================= UI ================= */
  return (
    <div className="cart-page container-fluid">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          {breadcrumbItems.map((item, i) => (
            <li
              key={i}
              className={`breadcrumb-item ${i === breadcrumbItems.length - 1 ? "active" : ""}`}
            >
              {i === breadcrumbItems.length - 1 ? (
                item.label
              ) : (
                <a href={item.link}>{item.label}</a>
              )}
            </li>
          ))}
        </ol>
      </nav>

      {isInsufficientBalance && (
        <>
          <h5
            style={{
              backgroundColor: "rgb(156, 36, 31)",
              padding: "10px",
              color: "white",
              width: "100%",
            }}
          >
            {" "}
            ⚠️ INSUFFICIENT WALLET BALANCE.
          </h5>
          <div
            style={{
              background: "#fff3cd",
              color: "#856404",
              padding: "12px 15px",
              border: "1px solid #ffeeba",
              marginBottom: "15px",
              borderRadius: "6px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontWeight: "500",
            }}
          >
            <span>
              Your Order Will Not Be Confirm Without Balance,Either Add Balance
              Or Continue!!
            </span>

            <button
              onClick={handleAddBalance}
              style={{
                background: "#ffc107",
                border: "none",
                padding: "6px 12px",
                borderRadius: "5px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Add Balance
            </button>
          </div>
          <h6
            style={{
              padding: "5px",
              color: "rgb(156, 36, 31)",
              width: "100%",
            }}
          >
            Note: Add Min. Rs 500/- Balance in Wallet.
          </h6>
        </>
      )}
      <div className="row">
        {/* LEFT */}
        <div className="col-lg-9">
          <div className="cart-header">
            <div className="cart-left">
              <input
                className="cl-check"
                type="checkbox"
                onChange={toggleAll}
              />

              <span>No</span>
              <span>Design ({cartData.length})</span>
            </div>

            <div className="cart-right">
              <span>Total Rs. {total}</span>

              <button className="remove-all" onClick={removeAll}>
                REMOVE ALL
              </button>
              <button
                className="wl-btn-danger"
                onClick={moveSelectedToWishlist}
              >
                MOVE All TO WISHLIST
              </button>
            </div>
          </div>

          {/* ITEMS */}
          <div className="cart-grid">
            {cartData.map((item, index) => (
              <div className="cart-item" key={item.cart_id}>
                <div className="item-no">
                  <input
                    className="cl-check"
                    type="checkbox"
                    checked={!!selected[item.cart_id]}
                    onChange={() => toggleSelect(item.cart_id)}
                  />
                  {index + 1}
                </div>
                {/* <div
                  className="cart-img-box"
                  onMouseMove={(e) => {
                    const img = e.currentTarget.querySelector("img");
                    const rect = e.currentTarget.getBoundingClientRect();

                    const x = ((e.clientX - rect.left) / rect.width) * 100;
                    const y = ((e.clientY - rect.top) / rect.height) * 100;

                    img.style.transformOrigin = `${x}% ${y}%`;
                    img.style.transform = "scale(2)";
                  }}
                  onMouseLeave={(e) => {
                    const img = e.currentTarget.querySelector("img");
                    img.style.transform = "scale(1)";
                  }}
                  onClick={() =>
                    navigate(`/product?code=${item.code}&icid=${item.icid}`)
                  }
                >
                  <img
                    src={`https://lifetimedesign.in/controlpanel/Designs/${item.image_url}`}
                    className="cart-img"
                    alt={item.code}
                  />
                </div> */}
                {/* <div
                  className="cart-img-box"
                  onMouseMove={(e) => {
                    const box = e.currentTarget;
                    const img = box.querySelector(".cart-img");
                    const zoom = box.querySelector(".zoom-preview");

                    const rect = box.getBoundingClientRect();

                    const x = e.clientX - rect.left;
                    const y = e.clientY - rect.top;

                    // move square
                    zoom.style.left = `${x - 40}px`;
                    zoom.style.top = `${y - 40}px`;
                    zoom.style.display = "block";

                    // zoom same image area
                    zoom.style.backgroundImage = `url(${img.src})`;
                    zoom.style.backgroundSize = `${rect.width * 2}px ${rect.height * 2}px`;
                    zoom.style.backgroundPosition = `
      -${x}px
      -${y}px
    `;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.querySelector(
                      ".zoom-preview",
                    ).style.display = "none";
                  }}
                  onClick={() =>
                    navigate(`/product?code=${item.code}&icid=${item.icid}`)
                  }
                >
                  <img
                    src={`https://lifetimedesign.in/controlpanel/Designs/${item.image_url}`}
                    className="cart-img"
                    alt={item.code}
                  />

                  <div className="zoom-preview"></div>
                </div> */}
                <div
                  className="cart-img-box"
                  onMouseMove={(e) => {
                    const box = e.currentTarget;
                    const img = box.querySelector(".cart-img");
                    const zoom = box.querySelector(".zoom-preview");

                    const rect = box.getBoundingClientRect();

                    const mouseX = e.clientX - rect.left;
                    const mouseY = e.clientY - rect.top;

                    // move square with cursor
                    zoom.style.left = `${mouseX - 50}px`;
                    zoom.style.top = `${mouseY - 50}px`;

                    // show zoomed part exactly under cursor
                    zoom.style.backgroundImage = `url(${img.src})`;

                    zoom.style.backgroundSize = `${rect.width * 2}px ${rect.height * 2}px`;

                    zoom.style.backgroundPosition = `${-mouseX * 2 + 0}px ${-mouseY * 2 + 50}px`;

                    zoom.style.display = "block";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.querySelector(
                      ".zoom-preview",
                    ).style.display = "none";
                  }}
                  onClick={() =>
                    navigate(`/product?code=${item.code}&icid=${item.icid}`)
                  }
                >
                  <img
                    src={`https://lifetimedesign.in/controlpanel/Designs/${item.image_url}`}
                    className="cart-img"
                    alt={item.code}
                  />

                  <div className="zoom-preview"></div>
                </div>
                {/* <div
                  className="cart-img-box"
                  onClick={() =>
                    navigate(`/product?code=${item.code}&icid=${item.icid}`)
                  }
                >
                  <img
                    src={`https://lifetimedesign.in/controlpanel/Designs/${item.image_url}`}
                    className="cart-img zoom-image"
                    alt={item.code}
                  />
                </div> */}

                <div className="cart-details">
                  <div>
                    <p>
                      <strong>Code :</strong> {item.code}
                    </p>

                    <p>
                      <strong>Area :</strong> {item.area}
                    </p>
                    <p>
                      <strong>Height :</strong> {item.packageno}
                    </p>
                    <p>
                      <strong>Concept :</strong> {item.concept}
                    </p>
                  </div>
                </div>
                <div className="cart-details">
                  <div>
                    <p>
                      <strong>Stiches :</strong> {item.stiches}
                    </p>
                    <p>
                      <strong>Colour :</strong> {item.color}
                    </p>
                    <p>
                      <strong>Width :</strong> {item.sequence}
                    </p>
                    <p>
                      <strong>Detail : </strong>
                      {item.description}
                    </p>
                  </div>
                </div>

                <div className="cart-price">Rs. {item.price || 0}</div>
                <div className="wl-item-actions1">
                  <button
                    className="wl-btn-view-sm"
                    onClick={() =>
                      navigate(`/product?code=${item.code}&icid=${item.icid}`)
                    }
                  >
                    VIEW
                  </button>

                  <button
                    className="wl-btn-gray-sm"
                    onClick={() => moveToWishlist(item)}
                  >
                    MOVE TO WISHLIST
                  </button>

                  <button
                    className="remove-all"
                    onClick={() => removeItem(item.cart_id)}
                  >
                    REMOVE
                  </button>
                </div>
                {/* <div className="cart-icons">
                  <button
                    className="icon-btn"
                    onClick={() =>
                      navigate(`/designe-details/${item.id}`, {
                        state: item,
                      })
                    }
                  >
                    <i className="bi bi-eye"></i>
                  </button>

                  <button
                    className="icon-btn"
                    onClick={() => moveToWishlist(item)}
                  >
                    <i className="bi bi-heart"></i>
                  </button>

                  <button
                    className="icon-btn"
                    onClick={() => removeItem(item.cart_id)}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </div> */}
              </div>
            ))}
          </div>

          <button className="continue-btn" onClick={() => navigate("/home")}>
            Continue Shopping
          </button>
        </div>

        {/* RIGHT */}
        <div className="col-lg-3">
          <div className="order-summary">
            <h4>ORDER SUMMARY</h4>

            <div className="summary-row">
              <span style={{ color: "#13415f", fontSize: "14px" }}>
                {cartData.length} DESIGN IN CART
              </span>
            </div>

            <div className="summary-row">
              <span style={{ color: "#a31111" }}>Total Order</span>
              <span style={{ color: "#a31111" }}>Rs. {total}</span>
            </div>
            <div className="summary-row">
              <span style={{ color: "#132f58" }}>Wallet Balance</span>
              <span style={{ color: "#132f58" }}>Rs. {balance}</span>
            </div>

            <div className="summary-row">
              <span style={{ color: balance >= total ? "green" : "#a31111" }}>
                Remaining Balance
              </span>
              <span style={{ color: balance >= total ? "green" : "#a31111" }}>
                Rs. {remaining}
              </span>
            </div>
            {/* {remaining < 0 && (
              <div
                style={{ color: "red", marginTop: "10px", fontWeight: "bold" }}
              >
                ❌ You do not have enough balance. Please add balance.
              </div>
            )} */}
            <button
              className="send-order"
              onClick={handleSendOrder}
              // disabled={remaining < 0}
              // style={{
              //   backgroundColor: remaining < 0 ? "#ccc" : "",
              //   cursor: remaining < 0 ? "not-allowed" : "pointer",
              // }}
            >
              SEND ORDER
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
